<template>
	<div class="member">
		<div class="headimg">
			<img v-if="imageUrl" :src="imageUrl" class="avatar" />
			<div class="file">
				{{$t('modifyUser.upload')}}
				<input type="file" class="inp" @change="handleAvatarSuccess" />
			</div>
		</div>
		<div class="list">
			<div class="name">{{$t('modifyUser.fullname')}}</div>
			<div class="msg">{{data.country == $t('modifyUser.China')? data.surname + data.name : data.name + data.surname}}</div>
		</div>
		<div class="list">
			<div class="name">{{$t('modifyUser.tel')}}</div>
			<div class="msg">
				<input type="number" v-if="edit" class="inps" v-model="phone"/>
				<span v-else>{{data.phone}}</span>
			</div>
			<div class="edit" @click="edit = !edit" v-if="!edit">{{$t('modifyUser.modify')}}</div>
		</div>
		<div class="list">
			<div class="name">{{$t('modifyUser.Gender')}}</div>
			<div>
				<el-radio v-model="radio" label="1">{{$t('modifyUser.male')}}</el-radio>
				<el-radio v-model="radio" label="2">{{$t('modifyUser.female')}}</el-radio>
			</div>
		</div>
		<div class="list">
			<div class="name">{{$t('modifyUser.region')}}</div>
			<div>
				<input type="text" class="input" v-model="country" />
				<input type="text" class="input" v-model="provinces" />
			</div>
		</div>
		<div class="list">
			<div class="name">{{$t('modifyUser.company')}}</div>
			<div>
				<input type="text" class="b_inp" v-model="mechanismName" />
			</div>
		</div>
		<div class="list">
			<div class="name"></div>
			<div class="btn" @click="upload">{{$t('modifyUser.preservation')}}</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				imageUrl: "",
				form: "",
				token: sessionStorage.getItem("token"),
				data: {},
				edit: false,
				radio: "",
				mechanismName: '',
				country: '',
				provinces: '',
				phone: ''
			};
		},
		methods: {
			handleAvatarSuccess(file) {
				let formdata = new FormData();
				this.imageUrl = window.webkitURL.createObjectURL(file.target.files[0]);
				formdata.append("file", file.target.files[0]);
				formdata.append('token', sessionStorage.getItem('token'));
				let url = "/open/upload/file"
				let data = {
					data: formdata,
					url: url
				}

				this.$fileUpload(data).then((res) => {
					this.form = res.data;
				})
			},
			//上传
			upload() {
				let data = {
					sex: this.radio,
					mechanismName: this.mechanismName,
					provinces: this.provinces,
					country: this.country,
					headImage: this.form,
					phone: this.phone,
					token: this.token
				}
				this.$put('/api/user/updateUser', data).then(res => {
					this.$message({
						message: this.$t('Tips.modifysuc'),
						type: 'success'
					});
				})
			},
			islogin() {
				if (this.token) {
					this.$get("/api/user/getUserAll", {
						token: this.token
					}).then(res => {
						this.data = res.data;
						this.country = this.data.country
						this.provinces = this.data.provinces
						this.mechanismName = this.data.mechanismName
						this.phone = this.data.phone
						this.imageUrl = this.data.headImage
						this.radio = this.data.sex.toString()
					});
				} else {
					this.$router.push("/login");
				}
			}
		},
		mounted() {
			this.islogin();
		}
	};
</script>
<style scoped>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
	    -webkit-appearance: none;
	    appearance: none; 
	    margin: 0; 
	}
	.member {
		width: 80%;
		height: 100%;
		padding-top: 45px;
	}

	.avatar {
		width: 120px;
		height: 120px;
		display: block;
	}

	.headimg {
		width: 120px;
		height: 120px;
		border-radius: 50%;
		overflow: hidden;
		border: 1px solid #f4f4f4;
		margin: 0 auto;
		position: relative;
		margin-bottom: 84px;
	}

	.file {
		width: 100%;
		height: 36px;
		bottom: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
		font-size: 14px;
		line-height: 36px;
		text-align: center;
		position: absolute;
	}

	.inp {
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	.name {
		/* padding-left: 51px; */
		color: #999999;
		font-size: 14px;
		text-align: left;
		margin-right: 35px;
		width: 100px;
		text-align: right;
	}

	.list {
		display: flex;
		margin-bottom: 30px;
		align-items: center;
	}

	.msg {
		text-align: left;
		font-size: 14px;
		color: #333333;
	}

	.edit {
		color: #0c62ad;
		font-size: 14px;
		margin-left: 10px;
	}

	.inps {
		border: 1px solid #eee;
	}

	.input {
		width: 198px;
		height: 42px;
		background: #f4f4f4;
		padding-left: 10px;
	}

	.b_inp {
		width: 767px;
		height: 42px;
		padding-left: 10px;
		background: #f4f4f4;
	}

	.btn {
		width: 124px;
		height: 36px;
		background: linear-gradient(0deg,
			rgba(5, 115, 203, 1) 0%,
			rgba(63, 159, 234, 1) 100%);
		border-radius: 2px;
		text-align: center;
		line-height: 36px;
		color: #fff;
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/sub/MemberData.vue